module.exports = __webpack_public_path__ + "mo/img/brand01.627cc730.png";